// src/components/Hero.js
import React from "react";
import { Container, Box, Typography, Button, Stack, Fade } from "@mui/material";
import { useTranslation } from "react-i18next";
import { useNavigate, Link } from "react-router-dom";
import { useState, useEffect } from "react";

const Hero = ({ title, subtitle, ctaLink, ctaLabel, ctaLink2, ctaLabel2 }) => {
  const { t } = useTranslation();
  const [show, setShow] = useState(false);
  useEffect(() => {
    setShow(true); // triggers fade-in on mount
  }, []);

  return (
    <>
      <Box
        sx={{
          backgroundColor: "primary.superlight",
          backgroundImage: "url(/img/hero5.png)", // Path to your background image
          backgroundSize: "cover", // Make sure the image covers the entire Hero section
          backgroundPosition: "center", // Keep the image centered
          textAlign: "center",
          px: 2,
          py: {
            xs: 6, // mobile
            sm: 12, // tablets
            md: ctaLabel || ctaLabel2 ? 16 : 10, // desktops
            xl: ctaLabel || ctaLabel2 ? 25 : 14, // large desktops
          },
        }}
      >
        <Fade in={show} timeout={1000}>
          <Typography
            variant="h1"
            sx={{
              color: "rgb(1, 47, 77)",
              mb: 1,
              fontSize: {
                xs: "2.3em",
              },
            }}
          >
            {title}
          </Typography>
        </Fade>
        <Fade in={show} timeout={1000} style={{ transitionDelay: "250ms" }}>
          <Typography
            sx={{ color: "rgb(1, 47, 77)", mb: ctaLabel || ctaLabel2 ? 4 : 0 }}
          >
            {subtitle}
          </Typography>
        </Fade>
        <Fade in={show} timeout={1000} style={{ transitionDelay: "400ms" }}>
          <div>
            {ctaLabel || ctaLabel2 ? (
              <Stack
                direction={{ xs: "column", sm: "row" }}
                spacing={2}
                justifyContent="center"
              >
                {ctaLabel && (
                  <Button
                    variant="contained"
                    color="secondary"
                    component={Link}
                    to={ctaLink}
                    sx={{
                      // backgroundColor: "#d09e28",
                      // color: "#fff",
                      borderRadius: "999px",
                      px: 4,
                      py: 1.5,
                      textTransform: "none",
                      fontWeight: "bold",
                    }}
                  >
                    {ctaLabel}
                    {/* {t("hero.cta_buy")} */}
                  </Button>
                )}
                {ctaLabel2 && (
                  <Button
                    variant="outlined"
                    color="primary"
                    component={Link}
                    to={ctaLink2}
                    sx={{
                      // borderColor: "#d09e28",
                      // color: "rgb(1, 47, 77)",
                      borderRadius: "999px",
                      px: 4,
                      py: 1.5,
                      textTransform: "none",
                      fontWeight: "bold",
                    }}
                  >
                    {ctaLabel2}
                    {/* {t("hero.cta_sell")} */}
                  </Button>
                )}
              </Stack>
            ) : null}
          </div>
        </Fade>
      </Box>
    </>
  );
};

export default Hero;
